import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'priceInput',
    'discountType',
    'discountValue',
    'previewContainer',
    'preview',
    'originalPrice',
    'discountAmount',
    'finalPrice'
  ]

  connect () {
    this.calculateDiscount()
  }

  calculateDiscount () {
    if (!this.hasAllRequiredTargets()) return

    const price = parseFloat(this.priceInputTarget.value) || 0
    const discountType = this.discountTypeTarget.value
    const discountValue = parseFloat(this.discountValueTarget.value) || 0

    if (price > 0 && discountType && discountValue > 0) {
      this.showPreview(price, discountType, discountValue)
    } else {
      this.hidePreview()
    }
  }

  showPreview (price, discountType, discountValue) {
    let discountAmount = 0
    let finalPrice = price

    if (discountType === 'percentage') {
      const clampedValue = Math.min(discountValue, 100)
      discountAmount = (price * clampedValue) / 100
      finalPrice = price - discountAmount
    } else if (discountType === 'fixed_amount') {
      discountAmount = Math.min(discountValue, price)
      finalPrice = price - discountAmount
    }

    finalPrice = Math.max(finalPrice, 0)

    this.originalPriceTarget.textContent = this.formatPrice(price)
    this.discountAmountTarget.textContent = this.formatPrice(discountAmount)
    this.finalPriceTarget.textContent = this.formatPrice(finalPrice)

    this.previewContainerTarget.style.display = 'block'
  }

  hidePreview () {
    if (this.hasPreviewContainerTarget) {
      this.previewContainerTarget.style.display = 'none'
    }
  }

  hasAllRequiredTargets () {
    return this.hasPriceInputTarget &&
           this.hasDiscountTypeTarget &&
           this.hasDiscountValueTarget &&
           this.hasPreviewContainerTarget &&
           this.hasOriginalPriceTarget &&
           this.hasDiscountAmountTarget &&
           this.hasFinalPriceTarget
  }

  formatPrice (price) {
    return new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(price)
  }
}
